const initialState = {
  builders: { data: { data: [], pagination: {} } },
  builder: { data: null }
};

const builderReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_BUILDERS':
      return {
        ...state,
        builders: { data: action.data }
      };
    case 'GET_BUILDER_BY_ID':
      return {
        ...state,
        builder: { data: action.data }
      };
    default:
      return state;
  }
};

export default builderReducer;